'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dAccount$002dResponse from "./presto.types$-Dashboard-Account-Response.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardAccountResponse$() {
}
export { $c_Lpresto_types$DashboardAccountResponse$ as $c_Lpresto_types$DashboardAccountResponse$ };
$p = $c_Lpresto_types$DashboardAccountResponse$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardAccountResponse$;
/** @constructor */
function $h_Lpresto_types$DashboardAccountResponse$() {
}
export { $h_Lpresto_types$DashboardAccountResponse$ as $h_Lpresto_types$DashboardAccountResponse$ };
$h_Lpresto_types$DashboardAccountResponse$.prototype = $p;
$p.l = (function() {
  return "DashboardAccountResponse";
});
$p.cHm = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dAccount$002dResponse.$c_Lpresto_types$DashboardAccountResponse(x$0.j(0), (x$0.j(1) | 0), x$0.j(2), x$0.j(3), x$0.j(4));
});
var $d_Lpresto_types$DashboardAccountResponse$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardAccountResponse$, "presto.types$DashboardAccountResponse$", ({
  Zi: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardAccountResponse$ as $d_Lpresto_types$DashboardAccountResponse$ };
var $n_Lpresto_types$DashboardAccountResponse$;
function $m_Lpresto_types$DashboardAccountResponse$() {
  if ((!$n_Lpresto_types$DashboardAccountResponse$)) {
    $n_Lpresto_types$DashboardAccountResponse$ = new $c_Lpresto_types$DashboardAccountResponse$();
  }
  return $n_Lpresto_types$DashboardAccountResponse$;
}
export { $m_Lpresto_types$DashboardAccountResponse$ as $m_Lpresto_types$DashboardAccountResponse$ };
//# sourceMappingURL=presto.types$-Dashboard-Account-Response$.js.map
